import React from "react";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import PageHeader from "./PageHeader";

const maroon = "#500000";

const RecordProfilePage = ({
  title,
  subtitle,
  backTo,
  backState,
  onBack,
  actions,
  children,
  maxWidth = 1200,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    navigate(backTo, backState ? { state: backState } : undefined);
  };

  return (
    <Box
      sx={{
        p: 3,
        minHeight: "calc(100vh - 96px)",
        bgcolor: "#fff",
        overflow: "auto",
      }}
    >
      <Box sx={{ maxWidth, mx: "auto" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          variant="outlined"
          sx={{
            mb: 2,
            textTransform: "none",
            color: maroon,
            borderColor: maroon,
            px: 2,
            py: 1,
            "&:hover": {
              backgroundColor: maroon,
              color: "white",
              borderColor: maroon,
            },
          }}
        >
          BACK TO TABLE
        </Button>

        <PageHeader title={title} subtitle={subtitle} actions={actions} />
        {children}
      </Box>
    </Box>
  );
};

export default RecordProfilePage;
